<div class="tab-content">
  <ng-content></ng-content>
  <h3 class="header" i18n="@@general.validation.remarks">Validation Remarks</h3>
  <div class="frame">
    <span class="frameHeader" i18n="@@general.remarks">Remarks</span>
    <span>{{ survey.validatorRemark }}</span>
  </div>
</div>
